<template>
  <div class="">
    <div
      v-if="authSuccess !== ''"
      class="Notice Notice--success"
    >
      {{ authSuccess }}
    </div>
    <social-account-auth-buttons
      :show-text-label="showSocialButtonLabels"
      :import-comment="importComment"
    />
    <div class="Authentication-divider">
      <span class="Authentication-text">
        OR
      </span>
    </div>
    <form
      ref="ReAuthForm"
      method="post"
      action="/re-authenticate"
      class="Form Form-password u-center"
      @submit.prevent
    >
      <input
        :value="csrfToken"
        name="_token"
        type="hidden"
      >
      <div class="Field-container">
        <form-input
          v-model="inputs.password"
          :error="validateStatus({ field: v$.inputs.password, serverKey: 'password', label: 'Password' })"
          :manual-validate="validateAll"
          name="password"
          placeholder="Enter password"
          label="Your password"
          input-type="password"
          @change="validateBlur({ field: v$.inputs.password, serverKey: 'password' })"
        />
        <a href="/forgotten-password">Forgotten your password?</a>
      </div>
      <button
        :class="[{'is-loading': ui.loading} ,'Button Button--primary Submit-button']"
        @click="submitUserAuthentication"
      >
        Continue
      </button>
    </form>
    <a
      class="Logout-button"
      @click="logOutUser"
    >
      <form
        class="LogoutForm"
        action="/logout"
        method="post"
      >
        <a
          class="post-to-logout-link"
          href="javascript:void(0);"
        >Not you? Log out</a>
      </form>
    </a>
  </div>
</template>
<script>

import { mapActions } from 'vuex';
import { required } from '@vuelidate/validators';
import validationMixin from '@/mixins/validation-mixin';
import useVuelidate from '@vuelidate/core';
import SocialAccountAuthButtons from '@/components/authentication/common/social-account-auth-buttons.vue';
import FormInput from '@/components/form/input.vue';

export default {
  components: {
    SocialAccountAuthButtons,
    FormInput,
  },
  mixins: [validationMixin],
  props: {
    importComment: {
      type: String,
      default: null,
    },
    shouldReload: {
      type: Boolean,
      default: false,
    },
    submitViaAjax: {
      type: Boolean,
      default: true,
    },
    showSocialButtonLabels: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      ui: {
        loading: false,
      },
      validateAll: false,
      inputs: {
        password: null,
      },
      authErrors: [],
      authSuccess: '',
    };
  },
  computed: {
    serverValidationErrors() {
      if (this.authErrors.length) {
        return { password: this.authErrors[0] };
      }
      return [];
    },
  },
  methods: {
    ...mapActions('user', [
      'reAuthenticateUser',
      'logOutUser',
    ]),
    authenticateUser() {
      this.ui.loading = true;
      this.resetAuthResponses();

      if (this.submitViaAjax) {
        this.submitAjax();
      } else {
        this.$refs.ReAuthForm.submit();
      }
    },
    submitAjax() {
      this.reAuthenticateUser(this.inputs.password)
        .then((response) => {
          this.authSuccess = response.data.message;
          this.$bus.$emit('bus:reauthentication-form:success');
          this.ui.loading = false;
          window.setTimeout(() => {
            this.resetAuthResponses();
          }, 3000);
        })
        .catch(({ response }) => {
          if (response) {
            this.authErrors = response.data.meta;
          }
          this.$bus.$emit('bus:reauthentication-form:error');
          this.ui.loading = false;
        });
    },
    resetAuthResponses() {
      this.authErrors = [];
      this.authSuccess = '';
    },
    submitUserAuthentication(pass) {
      if (this.v$.inputs.password.$invalid) {
        this.validateAll = true;
        return false;
      }

      this.authenticateUser(pass);
      return true;
    },
  },
  validations() {
    const rules = {
      inputs: {
        password: { required },
      },
    };

    return rules;
  },
};
</script>

<style lang="scss" scoped>
.Field-container {
  margin: .7em 0 0 0;
  text-align: left;

  .Form-field {
    margin-bottom: .3em;
  }
}
.Form-password {
  display: flex;
  flex-direction: column;

  a {
    font-size: .9rem;
  }
}
.Logout-button {
    display: block;
    padding-top: 10px;
}
.Submit-button {
  margin-top: 1em;
}
</style>
